import React from 'react';
import BigHeader from "../../components/BigHeader";
import './Sponsors.css'
import "bootstrap/dist/css/bootstrap.min.css";


const Sponsors = () => {


    return (
        <div>
        <BigHeader headerText={'Sponsors'} backgroundImage={'https://static.igem.wiki/teams/4602/wiki/images/images/background.jpg'}/>
		<div class="page-body">

			<h1 id="5cbb323a-82a4-47de-a441-483383057f17" class="">Fondation Bettencourt Schueller</h1>
			<figure id="44368ed6-089d-456e-8ecb-2ef353cf2242" class="image"><a
					href="https://static.igem.wiki/teams/4602/wiki/images/sponsors/fondation-bs.png"><img alt='1234234'
						src="https://static.igem.wiki/teams/4602/wiki/images/sponsors/fondation-bs.png" /></a></figure>
			<p id="0fa70962-0239-4215-97f7-949b20c6c38b" class="">The primary sponsor of the Paris - Bettencourt iGEM
				teams over the years is the Fondation Bettencourt Schueller, consistently supporting the projects
				financially and organisationally.</p>
			<h1 id="ea0d6462-e3b3-41e3-b45d-034a50fc27c7" class="">BioConvS and Inserm</h1>
			<figure id="df4aa437-a9dc-4bf3-b256-bcbf1788621d" class="image"><a
					href="https://static.igem.wiki/teams/4602/wiki/images/sponsors/bioconvs-sponsor.png"><img alt='12342344'
						src="https://static.igem.wiki/teams/4602/wiki/images/sponsors/bioconvs-sponsor.png" /></a>
			</figure>
			<figure id="1056039a-f3d1-4cf3-bab8-ac0ff8dc5b50" class="image"><a
					href="https://static.igem.wiki/teams/4602/wiki/images/sponsors/inserm-rvb-blanc.png"><img alt='12342344'
						src="https://static.igem.wiki/teams/4602/wiki/images/sponsors/inserm-rvb-blanc.png" /></a>
			</figure>
			<p id="ba600319-feb5-4f44-b849-67e32470ad6d" class="">BioConvergence for Health (BioConvS) is a Domain of
				Major Research and Innovation (DIM) funded by the Ile de France region. It aims to structure the
				communities of synthetic biology, biotherapy and bioproduction to guide the transition from scientific
				excellence to innovation, and to position Île-de-France region as an international reference in the
				domain. </p>
			<p id="052b65e8-b8d8-4811-a20c-e637e0938f94" class="">Inserm, the French National Institute of Health and
				Medical Research, is a key stakeholder for research and innovation in France. They are closely
				collaborating with BioConvS.</p>
			<p id="1ee10960-25db-4806-85e3-18e1619c187b" class="">They have kindly provided our team this year with a
				grant for kick-starting our project.</p>
			<h1 id="ef1f5ef6-81d1-471b-8142-2bb0abb72f89" class="">Learning Planet Institute and Paris Cité University
			</h1>
			<figure id="f3009b25-237f-4134-b1b8-11ac8953e0f7" class="image"><a
					href="https://static.igem.wiki/teams/4602/wiki/images/sponsors/lpi-logo.png"><img alt='1234234452341'
						style={{width:"288px"}}
						src="https://static.igem.wiki/teams/4602/wiki/images/sponsors/lpi-logo.png" /></a></figure>
			<figure id="3eb93852-0b23-4713-a85e-dd95a300e430" class="image"><a
					href="https://static.igem.wiki/teams/4602/wiki/images/sponsors/upc-png.png"><img alt='123423423151235' style={{width:"336px"}}
						src="https://static.igem.wiki/teams/4602/wiki/images/sponsors/upc-png.png" /></a></figure>
			<p id="3e8ba415-97ba-456c-9a1a-b2198ab08226" class="">The enduring legacy and tradition of Paris -
				Bettencourt iGEM teams is sustained by the ongoing support of our school, Learning Planet Institute
				(LPI), a part of the Paris Cité University. They have consistently provided our teams with work space
				and lab facilities.</p>
			<h1 id="5f84e73a-d56a-417c-84e8-38ba2d347c20" class="">New England Biolabs</h1>
			<p id="6021cbf8-dfdf-457b-83d2-708504866897" class="">
			</p>
			<figure id="937c633b-d477-4644-8c1f-58b6bd076c87" class="image"><a
					href="https://static.igem.wiki/teams/4602/wiki/images/sponsors/new-ingland-inverted.gif"><img alt='1234234512435125' style={{width:"500px"}}
						src="https://static.igem.wiki/teams/4602/wiki/images/sponsors/new-ingland-inverted.gif" /></a></figure>
			<p id="9d394d7c-7689-4df3-a590-ed4158495345" class="">New England Biolabs generously provided registered
				iGEM team with a kit including DNA Assembly mixes, Competent cells, Type IIS restriction enzymes, and
				DNA ligase. Our team has greatly benefited from this kit.</p>
			<h1 id="49c61842-e3e8-41fd-80c8-d710bc9dd1c5" class="">Twist bioscience</h1>
			<figure id="a3b4f53f-d267-4d3a-a6c5-b52c28ed01c4" class="image"><a
					href="https://static.igem.wiki/teams/4602/wiki/images/sponsors/twist-bioscience-blacklogo.jpg"><img alt='123423414351325'
						src="https://static.igem.wiki/teams/4602/wiki/images/sponsors/twist-bioscience-blacklogo.jpg" /></a>
			</figure>
			<p id="fa401cf2-d6a7-46f4-a952-3172a9615dc0" class="">Twist Biosciences kindly provided the registered iGEM
				teams up to 10 kb of free Twist Gene Fragments, which have been used by our team.</p>
			<h1 id="a64938fc-0fe1-4197-a1cd-c95a27ec9e5b" class="">IDT</h1>
			<figure id="3b6a45a6-8d5c-4ee7-bb04-5c512e88aca7" class="image"><a
					href="https://static.igem.wiki/teams/4602/wiki/images/sponsors/sponsor-idt.svg"><img alt='1234234123451234512345'
						src="https://static.igem.wiki/teams/4602/wiki/images/sponsors/sponsor-idt.svg" /></a></figure>
			<p id="3829f8d8-db8f-4bf9-b0f8-4e2c739ececf" class="">IDT kindly provided all of the registered iGEM team up
				to 20 kb of gBlocks™ Gene Fragments or equivalent value of other IDT products, which have been used by
				our team.</p>
			<h1 id="39902181-7ccc-491e-ae73-dc78f392b010" class="">Beckman Coulter</h1>
			<figure id="902def51-36bf-4081-be5d-30d37c52b054" class="image"><a
					href="https://static.igem.wiki/teams/4602/wiki/images/sponsors/beckman-coulter-inverted.png"><img alt='1234234152345121235'
						src="https://static.igem.wiki/teams/4602/wiki/images/sponsors/beckman-coulter-inverted.png" /></a>
			</figure>
			<p id="444402a7-9698-4016-9fc1-04bb928ff7a6" class="">Beckman Coulter kindly provided our team with
				CosMCPrep Plasmid Purification kit.</p>
			<h1 id="3be923e9-770e-4a47-865a-05ccb86c8020" class="">MathWorks</h1>
			<figure id="f629c4cd-aa83-4a69-aad1-922d5046e440" class="image"><a
					href="https://static.igem.wiki/teams/4602/wiki/images/sponsors/mathworks-logo-one-color-reversed.svg"><img alt='1234234123512354123423421'
						style={{width:"432px"}}
						src="https://static.igem.wiki/teams/4602/wiki/images/sponsors/mathworks-logo-one-color-reversed.svg" /></a>
			</figure>
			<p id="32874a74-00c0-4395-a64a-18333a534187" class="">This year, MathWorks has helped our team by providing
				a free license for MATLAB software.</p>
			<h1 id="f3c6caa4-54ee-42db-82f5-ca1356795022" class="">SnapGene</h1>
			<figure id="6140a8b0-8396-4808-9f55-08069511b589" class="image"><a
					href="https://static.igem.wiki/teams/4602/wiki/images/sponsors/snapgene-logo.png"><img alt='12342321351234123451234'
						style={{width:"432px"}}
						src="https://static.igem.wiki/teams/4602/wiki/images/sponsors/snapgene-logo.png" /></a></figure>
			<p id="91bb9d82-0886-4fa4-9bd9-85adf3b45259" class="">SnapGene, an iGEM sponsor, kindly provided three
				licenses for their software to our team.</p>
		</div>
        </div>
    )
}
export default Sponsors;